import fetchCustom from '../../../wp_helpers/fetchCustom';

export const getApplicationEvaluationConfig = async (applicationId) => {
    // TODO: Obtain this entry URL from a backend config
    const url = `/api/applications/${applicationId}/evaluation-config`;
    const response = await fetchCustom(url);
    return await response.json();
};
